import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function CTASection() {
  return (
    <div className="bg-white border-t border-slate-100 py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="relative overflow-hidden rounded-3xl p-8 sm:p-12 lg:p-14 text-center shadow-md"
          style={{
            background: 'linear-gradient(108deg, #01433E 0%, #035A52 24%, #024E5E 50%, #0A2E5B 74%, #1D184B 100%)'
          }}
        >
          {/* Subtle Ambient Glow */}
          <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-emerald-400/15 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -right-24 w-72 h-72 rounded-full bg-sky-400/15 blur-3xl pointer-events-none" />

          <div className="relative z-10 max-w-2xl mx-auto">
            <span className="inline-block text-xs font-mono font-bold tracking-widest uppercase text-[#86E4D6] mb-3">
              START YOUR JOURNEY
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white tracking-tight mb-3">
              Ready to begin your wellness journey?
            </h2>
            <p className="text-white/85 text-sm sm:text-base leading-relaxed mb-8 max-w-lg mx-auto">
              Join thousands of students who have transformed their lives through our certified programs.
            </p>
            <div className="flex flex-col sm:flex-row gap-3.5 justify-center items-center">
              <Link
                to="/classes"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-3.5 text-sm sm:text-base font-semibold text-slate-900 shadow-sm transition-all duration-200 hover:scale-[1.03] hover:shadow-md hover:bg-slate-50"
              >
                <span>Book Your First Class</span>
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
